import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { useApi } from '../../../api/useApi.hook';
import { RouteIndex } from '../../routeIndex';

const GoogleCallbackView = () => {
    const api = useApi();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current) return;
        handledRef.current = true;

        const params = new URLSearchParams(window.location.search);
        const status = params.get('status');
        const reason = params.get('reason');

        const mode = params.get('mode');

        if (status !== 'success') {
            if (reason === 'AccountAlreadyExists') {
                setError('Účet s tímto e-mailem již existuje. Přihlaste se pomocí e-mailového odkazu nebo hesla a Google propojte v nastavení účtu.');
            } else if (reason === 'AccountAlreadyConnected') {
                setError('Tento Google účet je již propojený s jiným účtem.');
            } else {
                setError(mode === 'connect'
                    ? 'Propojení se nezdařilo. Zkuste to prosím znovu.'
                    : 'Přihlášení přes Google se nezdařilo. Zkuste to prosím znovu.');
            }
            return;
        }

        // Connect flow — user is already logged in, just redirect to settings
        if (mode === 'connect') {
            navigate(RouteIndex.accountSettings + '?googleConnected=true', { replace: true });
            return;
        }

        const establish = async () => {
            const tokens = await api.v1.auth.refreshByCookie();
            await api.client.establishSession(tokens, {
                revokeOldSession: (sessionId) => api.v1.identities.revokeMySession(sessionId)
            });
            navigate(RouteIndex.documentList, { replace: true });
        };

        establish().catch(() => setError('Nepodařilo se přihlásit. Zkuste to prosím znovu.'));
    }, [api, navigate]);

    if (error) {
        return (
            <div className='flex justify-center items-center min-h-screen bg-gray-100'>
                <div className='bg-white rounded shadow p-8 max-w-sm w-full text-center'>
                    <p className='text-red-600 mb-4'>{error}</p>
                    <a href={RouteIndex.login} className='text-blue-600 hover:underline text-sm'>Zpět na přihlášení</a>
                </div>
            </div>
        );
    }

    return (
        <div className='flex justify-center items-center min-h-screen bg-gray-100'>
            <p className='text-gray-500'>Přihlašuji přes Google...</p>
        </div>
    );
};

export default GoogleCallbackView;
